import React from 'react';
import classes from './SuccessMessage.scss';
import { getLocalizedStrings } from '../../mfaPageLocalizedStrings';
import LoadIndicator from '../../../../../Common/CommonComponents/LoadingIndicator/loadingIndicator';


const formatPhoneNumbers = (value) => {
  if (!value) {
    return value;
  }
  if (value.length > 6) {
    return `(${value.slice(0, 3)})${value.slice(3, 6)}-${value.slice(6)}`;
  } else if (value.length > 3) {
    return `(${value.slice(0, 3)})${value.slice(3)}`;
  }
  return value;

};
const SuccessMessage = (props) => {
  const {
    handleGoToAccount,
    phoneNumber = '',
    fromProfile,
    isAddingNewNumber,
    newNumber,
    turnOn,
    onEnterKeyPress,
    showLoader
  } = props;

  if (showLoader) {
    return <LoadIndicator showLoading />;
  }

  const lastFourDigits = phoneNumber.toString().slice(-4);
  const strings = getLocalizedStrings('TurnOnMFA');
  let successInfo = (<div>
    <h3 className={classes.successHeading}>{strings.successHeading}</h3>
    <br />
    <p  className={classes.successContent}>{strings.successContent} {lastFourDigits}. </p>
    <br />
  </div>);
  if (fromProfile && !turnOn) {
    if (isAddingNewNumber) {
      successInfo = (<div>
        <h3 className={classes.successHeading}>{strings.mfaUpdatedHeading}</h3>
        <br />
        <p  className={classes.successContent}>{formatPhoneNumbers(newNumber)} {strings.mfaUpdatedContent}</p>
        <br />
      </div>);
    } else {
      successInfo = (<div>
        <h3 className={classes.successHeading}>{strings.mfaTurnOffHeading}</h3>
        <br />
        <p  className={classes.successContent}>{strings.mfaTurnOffContent}</p>
        <br />
      </div>);
    }
  }
  return (
    <div>
      {successInfo}
      <p>If you decide to make changes in the future, simply visit <span className={classes.mfaSuccessProfileLink} onClick={() => handleGoToAccount(true)} onKeyDown={(event) => onEnterKeyPress(event,() => handleGoToAccount(true))} tabIndex={0}>Profile Settings</span> in your My Account profile.</p>
      <br />
      <div>
        <button className={classes.mfaSendCode} onClick={() => handleGoToAccount()}><span>{fromProfile ? 'Ok' : 'Continue'}</span></button>
      </div>

    </div>
  );
};

export default SuccessMessage;
